import QuestionnaireForm from '../Common/QuestionnaireForm';
import * as Survey from "survey-react";
import { putAnonymousFormDataForCode } from '../../services/dataService';

class UnidentifyQFormCodeEntry extends QuestionnaireForm {
    
    constructor(props) {
        super(props);
        this.currentInstanceId = 0;
    }

   
    componentDidUpdate(prevProps) {

    if(this.props.directLoadedForm !== prevProps.directLoadedForm)
            this.populateDirectLoadedData();
    }

    populateDirectLoadedData = async () => {
        this.clearIntervalIfNecessary();


         this.model = new Survey.Model(this.props.directLoadedForm.formInfo.form);

        //CO#2622 File Uploads
        this.model.onValidateQuestion.add(function (sender, options) {
            
            if (options.name.toLowerCase().indexOf("fileupload") > -1) {
                const files = options.value;

                if (files && files.length > 0) {
                    const file = files[0];
                    const fileName = file.name || "";
                    const extension = fileName.split('.').pop().toLowerCase();

                    const acceptedTypes = (options.question.acceptedTypes || "").toLowerCase();
                    //const acceptedType = acceptedTypes.split('.').pop().toLowerCase();
                    //console.log('**********************' + extension + ", " + acceptedTypes);
                    if (acceptedTypes !== "" && acceptedTypes.indexOf(extension) === -1) {
                        if (acceptedTypes.indexOf(",") > -1)
                            options.error = "Only " + acceptedTypes.replaceAll(".", "") + " files are allowed.";
                        else
                            options.error = "Only " + acceptedTypes.replaceAll(".", "") + " file is allowed.";
                    }
                }
            }
        });

        this.setFormData(this.props.directLoadedForm.formInfo);
        this.currentInstanceId = this.props.directLoadedForm.instanceId;
                        
        this.setState({ loading: false, isComplete: false });

    };

    saveDataToOverride= async (completed) =>{
        return await putAnonymousFormDataForCode({ instanceId: this.currentInstanceId, completed: completed, responseCollection: this.model.data,
            lastUpdatedByUserId: this.instanceInfo.lastUpdatedByUserId, lastUpdated: this.instanceInfo.lastUpdated, 
            key1: this.props.key1, key2: this.props.key2
            // LW250806 CO#3591: Create and trigger "Thank you" email from Correspondence Manager
            , formName: this.props.directLoadedForm.formInfo.form.formName
        });  

    }

}
export default UnidentifyQFormCodeEntry;